import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { antdNotification } from '@hellodarwin/core/lib/features/providers/antd-app-provider';
import Button from '@hellodarwin/core/lib/components/common/button';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Download from '@hellodarwin/icons/dist/icons/Download';
import Tooltip from 'antd/es/tooltip';
import { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useTheme } from 'styled-components';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
const PdfViewer = ({ pdfFile, onDownload, onError }) => {
    const { t } = useTranslations();
    const theme = useTheme();
    const [numPages, setNumPages] = useState();
    const [error, setError] = useState(null);
    const containerRef = useRef(null);
    const containerPadding = 16;
    const [pageWidth, setPageWidth] = useState();
    useEffect(() => {
        function updateWidth() {
            if (containerRef.current) {
                setPageWidth(containerRef.current.clientWidth - containerPadding * 2);
            }
        }
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, []);
    const onDocumentLoadSuccess = ({ numPages: nextNumPages, }) => {
        setNumPages(nextNumPages);
        setError(null);
    };
    const onDocumentLoadError = (error) => {
        console.error('PDF loading error:', error);
        antdNotification.error({
            message: t('errors|pdf_error'),
            description: error.name,
            placement: 'bottomLeft',
        });
        setError(`Failed to load PDF: ${error.message}`);
        onError === null || onError === void 0 ? void 0 : onError(error);
    };
    if (error) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", { style: { width: '60%', margin: '0 auto' }, children: [_jsx("div", { style: {
                    background: theme.colors.beige_1,
                    width: '100%',
                    border: `1px solid ${theme.colors.grey_1}`,
                    display: 'flex',
                    padding: 4,
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    height: 52,
                    gap: 8,
                }, children: _jsx(Tooltip, { title: t('gamePlanPdf|download'), children: _jsx(Button, { defaultStyle: theme.colors.grey_1, headingIcon: _jsx(Download, { size: 24 }), size: "square", onClick: onDownload }) }) }), _jsx("div", { ref: containerRef, style: {
                    width: '100%',
                    height: 'calc(100% - 52px)',
                    border: `1px solid ${theme.colors.grey_1}`,
                    padding: containerPadding,
                    backgroundColor: theme.colors.grey_1,
                }, children: _jsx(Document, { file: pdfFile, onLoadSuccess: onDocumentLoadSuccess, onLoadError: onDocumentLoadError, children: _jsx("div", { style: { gap: 16, display: 'flex', flexDirection: 'column' }, children: Array.from(new Array(numPages), (_el, index) => (_jsx(Page, { pageNumber: index + 1, width: pageWidth }, `page_${index + 1}`))) }) }) })] }));
};
export default PdfViewer;
